<template>
  <b-modal
    :id="id"
    :title="this.$translate(header)"
    hide-footer
    size="lg"
    centered
    content-class="rounded-8"
    @close="clear"
    @show="show"
  >
    <div class="row">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <Select v-model="value" :options="entityOptions" :form-group-id="entity" :placeholder="entity" required />
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12 button-wrapper">
        <b-button variant="outline-secondary" size="lg" class="btn-delete-device px-5" @click="close">
          {{ 'Close' | i18n }}
        </b-button>
        <b-button variant="outline-primary" size="lg" class="btn-delete-device ml-4 px-5" :disabled="!value" @click="onSubmit">
          {{ 'Save' | i18n }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Select from '../../../../common/select';

export default {
  title: 'Add user',
  components: { Select },
  props: {
    onSave: {
      type: Function,
      default: () => {}
    },
    selectedEntity: {
      type: Array,
      default: () => []
    },
    list: {
      type: Array,
      default: () => []
    },
    id: {
      type: String,
      default: ''
    },
    header: {
      type: String,
      default: ''
    },
    entity: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      value: '',
      entityOptions: []
    };
  },
  methods: {
    onSubmit() {
      const u = this.list.find(u => u.id === this.value);
      this.onSave(u);
      this.close();
    },
    async show() {
      this.clear();
      const existIds = this.selectedEntity.map(u => u.id);
      const filtered = this.list.filter(u => !existIds.includes(u.id));
      this.entityOptions = filtered.map(item => ({
        value: item.id,
        text: item.username || item.email ? `${item.username ? item.username : ''}${item.email ? ` (${item.email})` : ''}` : item.company
      }));
    },
    close() {
      this.$root.$emit('bv::hide::modal', this.id);
      this.clear();
    },
    clear() {
      this.value = '';
      this.entityOptions = [];
    }
  }
};
</script>

<style lang="scss" scoped>
.button-wrapper {
  display: flex;
  justify-content: flex-end;
}

::v-deep .modal-header {
  border: none;
  padding-bottom: 0px!important;
}

::v-deep .rounded-8 {
  border-radius: 8px;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
